/**
 * @packageDocumentation
 * @module f1/record
 */

import { t_rec_open } from '../types';

export interface Pick {
  /**
   * Copies only specified `properties` from an `object` into a new object.
   *
   * @see Pick
   * @public
   * @param keys the list of keys to preserve from the value
   * @param dictionary the dictionary to select from
   * @function fn_pick
   * @example
   *
   * ```ts
   * pick(['foo', 'baz'], {foo: 1, bar: 2, baz: 3}) === {foo: 1, baz: 3}
   * ```
   */
  <K extends string[], V extends t_rec_open, R extends V>(keys: K, dictionary: V): R;
  /**
   * {@link FnPickValue}
   * @param value
   */
  <K extends string[], V extends t_rec_open, R extends V>(keys: K, dictionary: V): (keys: K, dictionary: V) => R;
}

/**
 * @see Pick
 */
export default (keys: string[], dictionary: t_rec_open): t_rec_open => {
  return {
    ...{},
    ...keys.reduce((acc, key) => {
      acc[key] = dictionary[key];
      return acc;
    }, {})
  };
};
